import { createActionWithCallbacks } from '@move-frontend/auth';
import { resetPassword } from '../../domain/use-cases/resetPassword';

export const resetPasswordWithCallbacks =
	createActionWithCallbacks(resetPassword);
